import { Reveal, SectionTag } from "./Shared";

const quotes = [
  {
    text: "They are the only seat at our property table with nothing to sell us. That clarity has paid for the fee many times over.",
    cite: "Family Office Principal · Singapore",
  },
  {
    text: "Every recommendation arrived as evidence, not opinion. Our yield is up double digits since the blueprint landed.",
    cite: "Private Landlord · Hong Kong",
  },
  {
    text: "Discreet, exacting, and always one step ahead of the boroughs our flats sit in.",
    cite: "Private Investor · Zurich",
  },
];

export default function Testimonials() {
  return (
    <section id="voices" data-testid="testimonials-section" className="border-b border-black/15">
      <div className="max-w-[1800px] mx-auto px-6 md:px-12 py-24 md:py-40">
        <SectionTag testId="testimonials-tag">In client voice</SectionTag>

        <div className="mt-16 md:mt-24">
          {quotes.map((q, i) => (
            <Reveal key={i} delay={0.05}>
              <figure
                data-testid={`testimonial-${i + 1}`}
                className={`relative py-14 md:py-20 border-t border-black/15 last:border-b max-w-5xl ${
                  i % 2 ? "ml-auto text-right" : ""
                }`}
              >
                <span
                  aria-hidden="true"
                  className={`absolute -top-8 font-serif text-[10rem] leading-none text-[#D4512D]/15 select-none ${
                    i % 2 ? "right-0" : "left-0"
                  }`}
                >
                  &ldquo;
                </span>
                <blockquote className="font-serif text-2xl sm:text-4xl lg:text-5xl leading-[1.15] tracking-tight text-[#0A0A0A]">
                  {q.text}
                </blockquote>
                <figcaption className="mt-8 font-mono text-[11px] uppercase tracking-[0.3em] text-black/50">
                  — {q.cite}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
